import { faCheck, faClockRotateLeft, faFloppyDisk, faLocationPin, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { dispDateHour, tempAlWait } from "../helpers";
import { getWaitime } from "../actions/waitime";
import { connect } from "react-redux";
import { listParcActive } from "../actions/parc";
import { listRidesActive } from "../actions/rides";
import Alert from "../components/Alert";

class Waitime extends React.Component {
    state = {
        openModal: false,
        attrs: [],
        parcs: [],
        datas: [],
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        selParcs: ["all"],
        selRides: ["all"],
        isStart: true
    }

    componentDidMount() {
        document.title = "Temps d'attente - DiscovRide | Calendriers d'affluence, Temps d'attente de parcs d'attractions (Futuroscope, Parc Asterix...)";
        this.props.handleMenu(false);
        if (localStorage.getItem('parcsWaitime') != undefined) {
            this.setState({selParcs: JSON.parse(localStorage.getItem('parcsWaitime'))});
        }
        if (localStorage.getItem('ridesWaitime') != undefined) {
            this.setState({selRides: JSON.parse(localStorage.getItem('ridesWaitime'))});
        }

        if (this.props.canContinue) {
            this.props.listParcActive();
            this.setState({
                alert: tempAlWait()
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.canContinue != this.props.canContinue) {
            if (this.props.canContinue) {
                this.props.listParcActive();
                this.setState({
                    alert: tempAlWait()
                });
            }
        }
        
        if (this.props.redParcsAct != prevProps.redParcsAct) {
            if (this.props.redParcsAct.alert.type == "succ") {
                this.setState({
                    alert: this.props.redParcsAct.alert,
                    parcs: this.props.redParcsAct.datas
                });
                this.props.listRidesActive({parcs: this.state.selParcs});
            } else {
                this.setState({
                    alert: this.props.redParcsAct.alert
                })
            }
        }

        if (this.props.redRidesAct != prevProps.redRidesAct) {
            if (this.props.redRidesAct.alert.type == "succ") {
                this.setState({
                    alert: this.props.redRidesAct.alert,
                    attrs: this.props.redRidesAct.datas,
                    isStart: false
                })
                if (this.state.isStart) {
                    this.props.getWaitime({parcs: this.state.selParcs, rides: this.state.selRides});
                }
            } else {
                this.setState({
                    alert: this.props.redRidesAct.alert
                })
            }
        }
        if (this.props.redGetWait != prevProps.redGetWait) {
            if (this.props.redGetWait.alert.type == "succ") {
                this.setState({
                    alert: this.props.redGetWait.alert,
                    datas: this.props.redGetWait.datas,
                    openModal: false
                })
            } else {
                this.setState({
                    alert: this.props.redGetWait.alert
                })
            }
        }
    } 

    cocheParc = (id) => {
        let res = false;

        if (this.state.selParcs.length > 0) {
            if (this.state.selParcs[0] == "all") {
                res = true;
            } else {
                if (this.state.selParcs.includes(id)) {
                    res = true;
                }
            }
        }

        return res;
    }

    cocheAttr = (id) => {
        let res = false;

        if (this.state.selRides.length > 0) {
            if (this.state.selRides[0] == "all") {
                res = true;
            } else {
                if (this.state.selRides.includes(id)) {
                    res = true;
                }
            }
        }

        return res;
    }

    handleCocheParc = (id, toAdd) => {
        let tempDatas = this.state.selParcs;
        if (toAdd) {
            if (tempDatas.length > 0) {
                if (tempDatas[0] == "all") {
                    tempDatas = [id];
                } else {
                    tempDatas.push(id);
                }
            } else {
                tempDatas = [id];
            }
        } else {
            if (tempDatas.length > 0) {
                if (tempDatas[0] == "all") {
                    // Récupérer tout les ids sauf l'id qu'il faut
                    tempDatas = [];
                    this.state.parcs.forEach(prc => {
                        if (prc.parcId != id) {
                            tempDatas.push(prc.parcId);
                        }
                    })
                } else {
                    tempDatas = tempDatas.filter(val => val != id);
                }
            }
        }
        this.props.listRidesActive({parcs: tempDatas});
        this.setState({
            selParcs: tempDatas,
            alert: tempAlWait()
        })
    }

    handleCocheAttr = (id, toAdd) => {
        let tempDatas = this.state.selRides;
        if (toAdd) {
            if (tempDatas.length > 0) {
                if (tempDatas[0] == "all") {
                    tempDatas = [id];
                } else {
                    tempDatas.push(id);
                }
            } else {
                tempDatas = [id];
            }
        } else {
            if (tempDatas.length > 0) {
                if (tempDatas[0] == "all") {
                    tempDatas = [];
                    this.state.attrs.forEach(rd => {
                        if (rd.rideId != id) {
                            tempDatas.push(rd.rideId);
                        }
                    })
                } else {
                    tempDatas = tempDatas.filter(val => val != id);
                }
            }
        }
        this.setState({
            selRides: tempDatas
        })
    }

    handleSaveSettings = (el) => {
        el.preventDefault();
        // Sauvegarde des données dans localStorage
        localStorage.setItem('parcsWaitime', JSON.stringify(this.state.selParcs));
        localStorage.setItem('ridesWaitime', JSON.stringify(this.state.selRides));

        // Appel de l'API
        this.props.getWaitime({parcs: this.state.selParcs, rides: this.state.selRides});
    }

    render() {
        return <div className="waitingp">
            <main className="main waitingp__main">
                <h2 className="main__ttl">Temps d'attente</h2>

                {/** Boutons choix **/}
                <header className="waitingp__hdr">
                    <button
                        title="Choisir le parc d'attraction"
                        aria-label="Choisir le parc d'attraction"
                        className="waitingp__btn btn"
                        onClick={() => this.setState({openModal: !this.state.openModal})}
                    >
                        <FontAwesomeIcon icon={faLocationPin} />
                        <span className="btn__txt">Choix du parc et des attractions</span>
                    </button>
                    <Link
                        title="Historique des temps d'attente"
                        aria-label="Historique des temps d'attente"
                        to="/temps-d-attente-historique"
                        className="waitingp__btn btn"
                    >
                        <FontAwesomeIcon icon={faClockRotateLeft} />
                        <span className="btn__txt">Historique</span>
                    </Link>
                </header>

                {/** Légende **/}
                <section className="waitingp__leg">
                    <span className="waitingp__legtxt">Légende :</span>
                    <div className="waitingp__legdiv">
                        <div className="waitingp__legcol waitgreen"></div>
                        <span className="waitingp__legtxt">&lt; 30 min</span>
                    </div>
                    <div className="waitingp__legdiv">
                        <div className="waitingp__legcol waitorange"></div>
                        <span className="waitingp__legtxt">&gt;= 30 min et &lt; 60 min</span>
                    </div>
                    <div className="waitingp__legdiv">
                        <div className="waitingp__legcol waitred"></div>
                        <span className="waitingp__legtxt">&gt;= 60 min</span>
                    </div>
                </section>

                {/** Temps d'attente **/}
                <ul className="waitingp__list">
                    { 
                        this.state.datas
                            .sort((a, b) => {
                                if (a.time < b.time) {
                                    return -1;
                                } else {
                                    return 1;
                                }
                            })
                            .map((attr, key) => {
                            return <li className={`waitingp__item ${
                                attr.time < 30 ? "waitgreen" :
                                    attr.time > 60 ? "waitred" :
                                        "waitorange"
                            } ${attr.isOpen == "closed" ? "waitgrey" : ""}`} key={`attr-${key}`}>
                                <h3 className="waitingp__item__ttl">{attr.name}</h3>
                                <span className="waitingp__item__time">{attr.isOpen == "closed" ? "Fermé" : `${attr.time} min`}</span>
                                <span className="waitingp__item__desc">
                                    Dernière mise à jour : {dispDateHour(attr.lastUpdate)}
                                </span>
                            </li>
                        })
                    }
                </ul>
                <span className="waitingp__linktxt">
                    Temps d'attentes reçus grâce à <a
                        href="https://www.wartezeiten.app/en/"
                        target="_blank"
                        className="waitingp__link"
                    >Wartezeiten</a>
                </span>

                {/** Modal choix du parc **/}
                <div className={`waitmod ${this.state.openModal && "waitmod--active"}`}>
                    <div className="waitmod__zone">
                        <button
                            title="Fermer la fenêtre"
                            aria-label="Fermer la fenêtre"
                            className="waitmod__btnclose"
                            onClick={() => {this.setState({openModal: !this.state.openModal})}}
                        >
                            <FontAwesomeIcon icon={faXmark} />
                        </button>
                        {/** Choix du parc **/}
                        <div className="waitmod__part">
                            <h3 className="waitmod__ttl">Choix du parc</h3>
                            <ul className="waitmod__list">
                                <li className="waitmod__item" title={"Sélectionner tous les parcs"} aria-label={"Sélectionner tous les parcs"} key={`parc--1`}>
                                    <button
                                        type="button"
                                        className="checkbox waitparcs"
                                        onClick={() => this.setState({selParcs: this.state.selParcs.length > 0 && this.state.selParcs[0] == "all" ? [] : ["all"]})}
                                    >
                                        <div className="checkbox__box waitmod__checkbox">
                                            <span className={`checkbox__check ${this.cocheParc(null) && "checkbox__check--active"}`}>
                                                <FontAwesomeIcon icon={faCheck} />
                                            </span>
                                        </div>
                                        <span className="checkbox__lab waitmod__checklab">Tout sélectionner</span>
                                    </button>
                                </li>
                                {
                                    this.state.parcs.map((parc, key) => {
                                        return <li className="waitmod__item" title={parc.name} aria-label={parc.name} key={`parc-${key}`}>
                                            <button
                                                type="button"
                                                className="checkbox waitparcs"
                                                onClick={() => this.handleCocheParc(parc.parcId, !this.cocheParc(parc.parcId))}
                                            >
                                                <div className="checkbox__box waitmod__checkbox">
                                                    <span className={`checkbox__check ${this.cocheParc(parc.parcId) && "checkbox__check--active"}`}>
                                                        <FontAwesomeIcon icon={faCheck} />
                                                    </span>
                                                </div>
                                                <span className="checkbox__lab waitmod__checklab">{parc.name}</span>
                                            </button>
                                        </li>
                                    })
                                }
                            </ul>
                        </div>

                        {/** Choix des attractions **/}
                        <div className="waitmod__part">
                            <h3 className="waitmod__ttl">Choix des attractions</h3>
                            <ul className="waitmod__list">
                                <li className="waitmod__item" title={"Tout sélectionner"} aria-label={"Tout sélectionner"} key={`attr--0`}>
                                    <button
                                        type="button"
                                        className="checkbox waitattrs"
                                        onClick={() => this.setState({selRides: this.state.selRides.length > 0 && this.state.selRides[0] == "all" ? [] : ["all"]})}
                                    >
                                        <div className="checkbox__box waitmod__checkbox">
                                            <span className={`checkbox__check ${this.cocheAttr(null) && "checkbox__check--active"}`}>
                                                <FontAwesomeIcon icon={faCheck} />
                                            </span>
                                        </div>
                                        <span className="checkbox__lab waitmod__checklab">{"Tout sélectionner"}</span>
                                    </button>
                                </li>
                                {this.state.attrs.map((attr, key) => {
                                    return <li className="waitmod__item" title={attr.name} aria-label={attr.name} key={`attr-${key}`}>
                                        <button
                                            type="button"
                                            className="checkbox waitattrs"
                                            onClick={() => this.handleCocheAttr(attr.rideId, !this.cocheAttr(attr.rideId))}
                                        >
                                            <div className="checkbox__box waitmod__checkbox">
                                                <span className={`checkbox__check ${this.cocheAttr(attr.rideId) && "checkbox__check--active"}`}>
                                                    <FontAwesomeIcon icon={faCheck} />
                                                </span>
                                            </div>
                                            <span className="checkbox__lab waitmod__checklab">{attr.name}</span>
                                        </button>
                                    </li>
                                })}
                            </ul>
                        </div>
                        {/** Validation **/}
                        <button
                            title="Valider ce choix"
                            aria-label="Valider ce choix"
                            className="waitmod__btn btn btn--secondary"
                            onClick={(el) => this.handleSaveSettings(el)}
                        >
                            <FontAwesomeIcon icon={faFloppyDisk} />
                            <span className="btn__txt">Enregistrer</span>
                        </button>
                    </div>
                </div>
                <Alert alert={this.state.alert} />
            </main>
        </div>
    }
}

const mapStatetoProps = state => {
    return {
        redGetWait: state.redGetWait,
        redRidesAct: state.redRidesAct,
        redParcsAct: state.redParcsAct
    }
}

const mapDispatchToProps = {
    getWaitime,
    listParcActive,
    listRidesActive
}

export default connect(mapStatetoProps, mapDispatchToProps)(Waitime);